export const FILE_UPLOAD_CATEGORIES = {
  customer: ["General", "KYC", "Contract", "Other"],
  dealer: ["General", "KYC", "Contract", "Other"],
};

